import {Table, Button, Popover, OverlayTrigger, Form} from 'react-bootstrap';
import React, {useState, useEffect} from 'react';
import '../css/make_tournament.css';
function MakeTournamentPage(){
 // consts here

 //functions here
    const logeverything = async() =>  {
        console.log("test");
    };

 // return here
 return (
     <>
     <div className="form">
        <Form>
            <Form.Group className="mb-3">
                <Form.Label>Tournament Name</Form.Label>
                <Form.Control type="text" placeholder="Enter name tournament" />
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label>number of players</Form.Label>
            </Form.Group>
            
            <Form.Check 
                type="switch"
                id="custom-switch"
                label="double elimination"
            />

            <Button variant="primary" onClick={() => logeverything()}>
                Make tournament
            </Button>
        </Form>
     </div>
     </>
 )
}

export default MakeTournamentPage